// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.headline[data-v-b7b24cd8] {\r\n  padding: 1rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
